import { Toaster as Sonner, type ToasterProps } from 'sonner'

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="top-right"
      richColors
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: 'group toast bg-white text-gray-900 border-gray-200 shadow-lg',
          error: 'bg-red-50 text-red-900 border-red-200',
          success: 'bg-green-50 text-green-900 border-green-200',
          warning: 'bg-yellow-50 text-yellow-900 border-yellow-200',
          info: 'bg-blue-50 text-blue-900 border-blue-200',
        },
      }}
      {...props}
    />
  )
}
